import { render, staticRenderFns } from "./Workshop.vue?vue&type=template&id=69908552&"
import script from "./Workshop.vue?vue&type=script&lang=js&"
export * from "./Workshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports